import { useEffect, useState } from "react"
import classes from './status.module.scss'

export default function Status({ ...props }) {

    const backgroundColors = [
        'bg-in-progress',
        'bg-under-review',
        'bg-first-cut-ready',
        'bg-awaiting-rm-approval',
        'bg-dark-blue',
        'bg-second-cut-ready',
        'bg-data-entry-maker-approval'
    ]

    const [pillClass, setPillClass] = useState('')
    const randomNo = Math.floor(Math.random() * backgroundColors.length)

    useEffect(() => {
        // console.log(props.status);
        
       

        switch (props?.status?.toLowerCase()) {
            case 'in draft': {
                setPillClass('bg-in-draft')
                break;
            }
            case 'in progress': {
                setPillClass('bg-in-progress')
                break;
            }
            case 'under review': {
                setPillClass('bg-under-review')
                break;
            }
            case 'tbd': {
                setPillClass('bg-tdb')
                break;
            }
            case 'first cut ready': {
                setPillClass('bg-first-cut-ready')
                break;
            }
            case 'under stakeholder review': {
                setPillClass('bg-under-stakeholder-review')
                break;
            }
            case 'second cut ready': {
                setPillClass('bg-second-cut-ready')
                break;
            } case 'awaiting rm approval': {
                setPillClass('bg-awaiting-rm-approval')
                break;
            }
            case 'awaiting branchops approval': {
                setPillClass('bg-awaiting-branchops-approval')
                break;
            }
            case 'awaiting compliance approval': {
                setPillClass('bg-awaiting-compliance-approval')
                break;
            }
            case 'awaiting seo approval': {
                setPillClass('bg-awaiting-seo-approval')
                break;
            }
            case 'awaiting dvu approval': {
                setPillClass('bg-awaiting-dvu-approval')
                break;
            }
            case 'Awaiting Data Entry Maker approval': {
                setPillClass('bg-data-entry-maker-approval')
                break;
            }
            case 'Awaiting Data Entry Checker approval': {
                setPillClass('bg-awaiting-data-entry-checker-approval')
                break;
            }
            case 'Awaiting Video KYC': {
                setPillClass('bg-awaiting-video-kyc')
                break;
            }
            case 'Awaiting video KYC approval': {
                setPillClass('bg-awaiting-video-KYC-approval')
                break;
            }
            case 'Agreement Generation In Progress': {
                setPillClass('bg-agreement-generation-in-progress')
                break;
            }
            case 'Awaiting Esign Completion': {
                setPillClass('bg-awaiting-esign-completion')
                break;
            }
            case 'Merging in Progress': {
                setPillClass('bg-merging-in-progress')
                break;
            }

            case 'Verification Pending': {
                setPillClass('bg-verification-pending')
                break;
            }
            case 'terminated': {
                setPillClass('bg-terminated')
                break;
            }
            case 'rejected': {
                setPillClass('bg-rejected')
                break;
            }
            case 'Welcome Letter Generation In Progress': {
                setPillClass('bg-welcome-letter-generation-in-progress')
                break;
            }
            case 'Awaiting Welcome Letter Generation': {
                setPillClass('bg-awaiting-welcome-letter-generation')
                break;
            }
            case 'welcome letter generation in progress': {
                setPillClass('bg-welcome-letter-generation-in-progress')
                break;
            }
            case 'Welcome Letter Sent': {
                setPillClass('bg-welcome-letter-sent')
                break;
            }
            default: {
                setPillClass(backgroundColors[randomNo])
            }
        }
    }, [props?.status])

    useEffect(()=>{
        switch(props?.requestChange?.toLowerCase()){
            case 'pending response': {
                setPillClass('pending-response')
                break;
            }
            case 'completed': {
                setPillClass('completed')
                break;
            }
        }
    },[props?.requestChange])


    return (
        <>
        <div className={`h-30px text-black rounded-pill border-1 border-solid max-w-fit-content ${classes[pillClass]} d-flex align-items-center px-2 text-capitalize`}>
            <span className="mt-1 text-nowrap">
                {props?.status}                 {props?.requestChange}

            </span>
        </div>
        {/* <div className={`h-30px text-black rounded-pill border-1 border-solid max-w-fit-content ${classes[pillClass]} d-flex align-items-center px-2 text-capitalize`}>
            <span className="mt-1 text-nowrap">
            </span>
        </div> */}
        </>  
    )
}